import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  generateScriptModal: false,
  generateScriptWithAIModal: false,
  chatGptData: undefined,
  formData: {
    language: "",
    videoTopic: "",
    videoObjective: "",
    targetAudience: "",
    videoTone: "",
    totalSlide: "",
  },
  selectedSlideData: {
    currentSelectedSlide: 0,
    title: "",
    content: "",
    bulletpoints: [],
  },
  selectedSlideData: {
    currentSelectedSlide: 0,
    title: "",
    content: "",
    bulletpoints: [],
  },
  userAudioScript: [],
  elevenLabsVoices: [],
  subtitles: [],
  elevenLabsGender: [],
  elevenLabsAccents: [],
  elevenLabsAges: [],
  openAiVoiceId: "alloy",
};

const scriptSlice = createSlice({
  name: "script",
  initialState,
  reducers: {
    setGenerateScriptModal: (state, action) => {
      state.generateScriptModal = action.payload;
    },
    setGenerateScriptWithAIModal: (state, action) => {
      state.generateScriptWithAIModal = action.payload;
    },
    setChatGptData: (state, action) => {
      state.chatGptData = action.payload;
    },
    setGenerateScriptModal: (state, action) => {
      state.generateScriptModal = action.payload;
    },
    setFormData: (state, action) => {
      state.formData = action.payload;
    },
    setSelectedSlideData: (state, action) => {
      state.selectedSlideData = action.payload;
    },
    setUserAudioData: (state, action) => {
      state.userAudioScript = action.payload;
    },
    setElevenLabVoices: (state, action) => {
      state.elevenLabsVoices = action.payload;
    },
    setSubtitles: (state, action) => {
      state.subtitles = action.payload;
    },
    setElevenLabsAges: (state, action) => {
      state.elevenLabsAges = action.payload;
    },
    setElevenLabsAccents: (state, action) => {
      state.elevenLabsAccents = action.payload;
    },
    setElevenLabsGender: (state, action) => {
      state.elevenLabsGender = action.payload;
    },
    setOpenAiVoiceId: (state, action) => {
      state.openAiVoiceId = action.payload;
    },
  },
});

export const {
  setGenerateScriptModal,
  setGenerateScriptWithAIModal,
  setChatGptData,
  setFormData,
  setSelectedSlideData,
  setUserAudioData,
  setElevenLabVoices,
  setSubtitles,
  setElevenLabsAges,
  setElevenLabsAccents,
  setElevenLabsGender,
  setOpenAiVoiceId,
} = scriptSlice.actions;
export default scriptSlice.reducer;
